import { Pipe, PipeTransform } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';

const MS_JSON_DATE = /^\/Date\((\d+)\)\/$/;
const ISO_NO_TIMEZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Преобразует значение даты с API (UTC) в Date и форматирует в локали браузера.
 * Строки ISO без суффикса зоны считаются UTC (как при сериализации DateTime из БД).
 */
export function utcApiValueToLocalDate(value: string | Date | number | null | undefined): Date | null {
	if (value == null || value === '') {
		return null;
	}
	if (value instanceof Date) {
		return isNaN(value.getTime()) ? null : value;
	}
	if (typeof value === 'number') {
		const d = new Date(value);
		return isNaN(d.getTime()) ? null : d;
	}
	const s = String(value).trim();
	if (!s) {
		return null;
	}
	const ms = MS_JSON_DATE.exec(s);
	if (ms) {
		const d = new Date(+ms[1]);
		return isNaN(d.getTime()) ? null : d;
	}
	if (/Z$/i.test(s) || /[+-]\d{2}:?\d{2}$/.test(s)) {
		const d = new Date(s);
		return isNaN(d.getTime()) ? null : d;
	}
	if (ISO_NO_TIMEZONE.test(s)) {
		const d = new Date(`${s}Z`);
		return isNaN(d.getTime()) ? null : d;
	}
	if (ISO_DATE_ONLY.test(s)) {
		const d = new Date(`${s}T00:00:00Z`);
		return isNaN(d.getTime()) ? null : d;
	}
	return null;
}

@Pipe({ name: 'utcDateFormat' })
export class UtcDateFormatPipe implements PipeTransform {
	constructor(private intl: IntlService) {}

	transform(value: string | Date | number | null | undefined, format: string): string {
		const date = utcApiValueToLocalDate(value);
		if (!date) {
			return '';
		}
		return this.intl.formatDate(date, format);
	}
}
